export const CHART_TYPES = {
  LINE_CHART: "LINE_CHART",
  BAR_CHART: "BAR_CHART",
  PIE_CHART: "PIE_CHART",
  BOX_PLOT: "BOX_PLOT",
  STACKED_BAR_CHART: "STACKED_BAR_CHART",
};

export const CHART_TYPE_MAP = {
  LineChart: CHART_TYPES.LINE_CHART,
  BarChart: CHART_TYPES.BAR_CHART,
  StackedBarChart: CHART_TYPES.STACKED_BAR_CHART,
  PieChart: CHART_TYPES.PIE_CHART,
};

export const VISUALIZATION_TYPE = {
  Tabular: "Tabular",
  Metric: "Metric",
  ...CHART_TYPE_MAP,
};

export const COLOR_PANEL = [
  "var(--violet-600)",
  "var(--yellow-600)",
  "var(--green-600)",
  "var(--orange-600)",
  "var(--blue-600)",
  "var(--purple-600)",
  "var(--teal-600)",
  "var(--red-600)",
  "var(--pink-600)",
  "var(--teal-400)",
  "var(--violet-400)",
  "var(--yellow-400)",
  "var(--green-400)",
  "var(--orange-400)",
  "var(--blue-400)",
];

/**
 * Returns a color for the given index.
 * Uses COLOR_PANEL first, then generates HSL colors for overflow.
 */
export const getColorForIndex = index => {
  if (index < COLOR_PANEL.length) return COLOR_PANEL[index];
  // Generate evenly spaced hues for indices beyond the palette
  const overflowIndex = index - COLOR_PANEL.length;
  const hue = (overflowIndex * 137.5) % 360; // golden angle for good distribution
  return `hsl(${Math.round(hue)}, 65%, 50%)`;
};
